//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import wx from 'weixin-js-sdk'; 

export default {
  components: {
      cmBlank
  },
  data () {
    return {
      blankShow:true,
      orderCode:'',
      list:{
          expName: '',
          number: '',
          trackings: []
      },
    }
  },
  computed: {
   
  },
  created(){
    this.orderCode = this.$route.params.code;
    this.config();
    if(this.orderCode){
        this.search();
    }
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.getList();
    },
    resetSearch(){
        this.orderCode = '';
        this.list = [];
        this.getList();
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ['barCode'],
            success: function (res) {
                setTimeout(() => {
                    that.orderCode = res.resultStr.split(',')[1];
                    let prefix = that.orderCode.substring(0,4);
                    if(prefix == 'JDVG'){
                        that.orderCode = that.orderCode.substring(0,15);
                    }
                    that.search();
                 }, 300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    getList(){
        this.$api.queryExpress({code:this.orderCode}).then((res)=>{
            if(res){
                this.list = res.data;
                this.blankShow = res.data.trackings.length > 0 ? false : true;
            }
        }) 
    },
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/queryExpress.vue